import { render } from "./RedDot.vue?vue&type=template&id=6b9ce442&scoped=true"
import script from "./RedDot.vue?vue&type=script&lang=js"
export * from "./RedDot.vue?vue&type=script&lang=js"

import "./RedDot.vue?vue&type=style&index=0&id=6b9ce442&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9ce442"]])

export default __exports__